// Holds global Config flags (from backend `Config.get_config_info_for_user`)
// so ClientData/Testator getters can read them without threading the value
// through every consistency check and section validator.
export const clientConfig = {
  enablePourOverWills: false,
};

export function setClientConfig(supportInfo = {}) {
  clientConfig.enablePourOverWills = Boolean(supportInfo.enablePourOverWills);
}
